import {
    NONDELIVERYREASONS_REQUEST, NONDELIVERYREASONS_SUCCESS, NONDELIVERYREASONS_ERROR, NONDELIVERYREASONS_params,
    NONDELIVERYSOLUTION_REQUEST, NONDELIVERYSOLUTION_SUCCESS, NONDELIVERYSOLUTION_ERROR, NONDELIVERYSOLUTION_params,
    NONDELIVERYPOST_REQUEST, NONDELIVERYPOST_SUCCESS, NONDELIVERYPOST_ERROR, CLEARNONDELIVERYPOSTSTATUS, NONDELIVERYPOST_params,
    SOLVENONDELIVERY_REQUEST, SOLVENONDELIVERY_SUCCESS, SOLVENONDELIVERY_ERROR, CLEARSOLVENONDELIVERYSTATUS, SOLVENONDELIVERYPOST_params
} from "../actions/nonDelivery";
import apiCalls from "utils/api";
import Vue from "vue";

const state = {
    nonDeliveryReasons: [],
    nonDeliveryReasonsStatus: "",
    nonDeliverySolution: [],
    nonDeliverySolutionStatus: "",

    nonDeliveryPostStatus: "",
    solveNonDeliveryPostStatus: ""
};

const getters = {
    getNonDeliveryReasons: state => {
        return state.nonDeliveryReasons.map((e) => {

            return {
                value: e.ReasonId,
                text: e.Reason
            }
        })
    },
    getNonDeliverySolution: state => {
        return state.nonDeliverySolution.map((e) => {

            return {
                value: e.ReasonId,
                text: e.Reason
            }
        })
    },

    getnonDeliveryReasonsStatus: state => state.nonDeliveryReasonsStatus,
    getnonDeliverySolutionStatus: state => state.nonDeliverySolutionStatus,

    getnonDeliveryPostStatus: state => state.nonDeliveryPostStatus,
    getSolveNonDeliveryPostStatus: state => state.solveNonDeliveryPostStatus,
};

const actions = {
    [NONDELIVERYPOST_REQUEST]: ({ commit, dispatch }, data) => {
        commit(NONDELIVERYPOST_REQUEST);

        var parameters = [
            {
                name: "@TRIPLINE",
                value: data.TripLineId.toString()
            },
            {
                name: "@SHIPMENT",
                value: data.ShipmentId
            },
            {
                name: "@REASONID",
                value: data.reasonId.toString()
            },
            {
                name: "@REMARK",
                value: data.nonDeliveryBody
            }
        ]
        NONDELIVERYPOST_params.parameters = JSON.stringify(parameters);

        apiCalls.apiCall({ url: "post", method: "GET", params: NONDELIVERYPOST_params })
            .then(resp => {
                commit(NONDELIVERYPOST_SUCCESS, resp.data);
            })
            .catch(() => {
                commit(NONDELIVERYPOST_ERROR);
            });
    },
    [SOLVENONDELIVERY_REQUEST]: ({ commit, dispatch }, data) => {
        commit(SOLVENONDELIVERY_REQUEST);

        var parameters = [
            {
                name: "@NONDELIVERY",
                value: data.nonDeliveryId.toString()
            },
            {
                name: "@REASONID",
                value: data.reasonId.toString()
            }
        ]
        SOLVENONDELIVERYPOST_params.parameters = JSON.stringify(parameters);

        apiCalls.apiCall({ url: "post", method: "GET", params: SOLVENONDELIVERYPOST_params })
            .then(resp => {
                commit(SOLVENONDELIVERY_SUCCESS, resp.data);
            })
            .catch(() => {
                commit(SOLVENONDELIVERY_ERROR);
            });
    },
    [NONDELIVERYREASONS_REQUEST]: ({ commit, dispatch }) => {
        commit(NONDELIVERYREASONS_REQUEST);
        apiCalls.apiCall({ url: "get", method: "GET", params: NONDELIVERYREASONS_params })
            .then(resp => {
                commit(NONDELIVERYREASONS_SUCCESS, resp.data);         
                dispatch(NONDELIVERYSOLUTION_REQUEST);
            })
            .catch((e) => {
                commit(NONDELIVERYREASONS_ERROR);
            });
    },
    [NONDELIVERYSOLUTION_REQUEST]: ({ commit, dispatch }) => {
        commit(NONDELIVERYSOLUTION_REQUEST);
        apiCalls.apiCall({ url: "get", method: "GET", params: NONDELIVERYSOLUTION_params })
            .then(resp => {
                commit(NONDELIVERYSOLUTION_SUCCESS, resp.data);
            })
            .catch(() => {
                commit(NONDELIVERYSOLUTION_ERROR);
            });
    }
};

const mutations = {
    [NONDELIVERYPOST_REQUEST]: state => {
        state.nonDeliveryPostStatus = "loading";
    },
    [NONDELIVERYPOST_SUCCESS]: (state, resp) => {
        state.nonDeliveryPostStatus = "success";
    },
    [NONDELIVERYPOST_ERROR]: state => {
        state.nonDeliveryPostStatus = "error";
    },
    [CLEARNONDELIVERYPOSTSTATUS]: state => {
        state.nonDeliveryPostStatus = "";
    },

    [SOLVENONDELIVERY_REQUEST]: state => {
        state.solveNonDeliveryPostStatus = "loading";
    },
    [SOLVENONDELIVERY_SUCCESS]: (state, resp) => {
        state.solveNonDeliveryPostStatus = "success";
    },
    [SOLVENONDELIVERY_ERROR]: state => {
        state.solveNonDeliveryPostStatus = "error";
    },
    [CLEARSOLVENONDELIVERYSTATUS]: state => {
        state.solveNonDeliveryPostStatus = "";
    },

    [NONDELIVERYREASONS_REQUEST]: state => {
        state.nonDeliveryReasonsStatus = "loading";
    },
    [NONDELIVERYREASONS_SUCCESS]: (state, resp) => {
        state.nonDeliveryReasonsStatus = "success";
        state.nonDeliveryReasons = resp.data;
        Vue.set(state, "nonDeliveryReasons", resp.data);
    },
    [NONDELIVERYREASONS_ERROR]: state => {
        state.nonDeliveryReasonsStatus = "error";
    },

    [NONDELIVERYSOLUTION_REQUEST]: state => {
        state.nonDeliverySolutionStatus = "loading";
    },
    [NONDELIVERYSOLUTION_SUCCESS]: (state, resp) => {
        state.nonDeliverySolutionStatus = "success";
        state.nonDeliverySolution = resp.data;

        Vue.set(state, "nonDeliverySolution", resp.data);
    },
    [NONDELIVERYSOLUTION_ERROR]: state => {
        state.nonDeliverySolutionStatus = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
